<div class="w-full" [formGroup]="formGroup">
    @if(slot.label){
        <label class="block text-[14px] font-medium text-foreground opacity-80 mb-2">
            {{ slot.label }}
        </label>
    }
    
    <app-date-range-picker
        (click)="$event.stopPropagation()"
        [startValue]="getStartValue()"
        [endValue]="getEndValue()"
        [showLabel]="false"
        (startDateChange)="onStartDateChange($event)"
        (endDateChange)="onEndDateChange($event)"
    ></app-date-range-picker>
</div>
